import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import Loader from '@/components/common/Loader';
import { lazy, Suspense } from 'react';

interface Options {
  fallback?: React.ReactNode;
  errorFallback?: React.ReactNode;
  onError?: (error: Error, errorInfo: React.ErrorInfo) => void;
}

export default function loadable<T extends React.ComponentType<any>>(
  importFunc: () => Promise<{ default: T }>,
  { fallback = <Loader />, errorFallback, onError }: Options = {}
) {
  const LazyComponent = lazy(importFunc);
  return (props: React.ComponentProps<T>) => (
    <ErrorBoundary fallback={errorFallback} onError={onError}>
      <Suspense fallback={fallback}>
        <LazyComponent {...props} />
      </Suspense>
    </ErrorBoundary>
  );
}
